import { useResolveColorTheme } from '@utils/useResolveColorTheme';
import styled from 'styled-components';

export const Container = styled.section`
  > div {
    min-height: calc(100vh - 4rem);
    background: ${() =>
    useResolveColorTheme({ light: '#eeeeee', dark: '#474747' })};
    padding: 1rem;
  }
`;
